/** How the background conflict analysis ENDED: done, skipped, failed. In-flight states
 *  belong to the cost row's progress bar. */
export default function SafetyStatus({ job, result }) {
  const blocked = result?.safety_blocked;
  if (blocked) {
    return (
      <div className="ne-safety-status blocked">
        <b>Conflict analysis skipped.</b> This demand is denser than the network
        can carry, so a 15-minute simulation of it would measure a jam. The
        traffic results above are unaffected.
      </div>
    );
  }
  if (!job) return null;
  if (job.status === 'queued' || job.status === 'running') return null;
  if (job.status === 'done') {
    const n = job.safety?.conflicts_ttc;
    return (
      <div className="ne-safety-status done">
        {/* Name the measure: conflicts_ttc is the TTC threshold alone, not a total of all four. */}
        Conflict analysis complete
        {n != null ? ` — ${n.toLocaleString()} TTC conflicts` : ''}.
        {' '}Open the report for the breakdown.
      </div>
    );
  }
  return (
    <div className="ne-safety-status blocked">
      Conflict analysis did not complete{job.error ? `: ${job.error}` : '.'}
      {' '}The traffic results above are unaffected.
    </div>
  );
}
